const pathwaysToGenericRoles = {
	'Allied Health': 'genericRoles.lvl1',
	'Behavioral Health': 'genericRoles.lvl1',
	'Business Analysis': 'genericRoles.lvl1',
	'Customer Service Leadership': 'genericRoles.lvl1',
	Cybersecurity: 'genericRoles.lvl1',
	'Data Analytics and Science': 'genericRoles.lvl1',
	'Field Leadership': 'genericRoles.lvl1',
	'Field Sales': 'genericRoles.lvl1',
	'Financial Analysis': 'genericRoles.lvl1',
	'Human Resources': 'genericRoles.lvl1',
	'Information Technology Management': 'genericRoles.lvl1',
	Labs: 'genericRoles.lvl1',
	Marketing: 'genericRoles.lvl1',
	Nursing: 'genericRoles.lvl1',
	'Product Management': 'genericRoles.lvl1',
	'Project Management': 'genericRoles.lvl1',
	'Software Engineering': 'genericRoles.lvl1',
	'Supply Chain': 'genericRoles.lvl1',
};

const pathwaysToSpecificRoles = {
	'Allied Health': 'specificRoles.lvl1',
	'Behavioral Health': 'specificRoles.lvl1',
	'Business Analysis': 'specificRoles.lvl1',
	'Customer Service Leadership': 'specificRoles.lvl1',
	Cybersecurity: 'specificRoles.lvl1',
	'Data Analytics and Science': 'specificRoles.lvl1',
	'Field Leadership': 'specificRoles.lvl1',
	'Field Sales': 'specificRoles.lvl1',
	'Financial Analysis': 'specificRoles.lvl1',
	'Human Resources': 'specificRoles.lvl1',
	'Information Technology Management': 'specificRoles.lvl1',
	Labs: 'specificRoles.lvl1',
	Marketing: 'specificRoles.lvl1',
	Nursing: 'specificRoles.lvl1',
	'Product Management': 'specificRoles.lvl1',
	'Project Management': 'specificRoles.lvl1',
	'Software Engineering': 'specificRoles.lvl1',
	'Supply Chain': 'specificRoles.lvl1',
};

export const refinementListAttributeMapping = {
	Business: 'hierarchicalInterests.lvl1',
	'Certificates & bootcamps': 'programType.lvl1',
	Healthcare: 'hierarchicalInterests.lvl1',
	Technology: 'hierarchicalInterests.lvl1',
};

export const genericRolesRefinementListAttributeMapping = {
	...pathwaysToGenericRoles,
	...refinementListAttributeMapping,
};

export const specificRolesRefinementListAttributeMapping = {
	...pathwaysToSpecificRoles,
	...refinementListAttributeMapping,
};
